"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.walkContentTreeMap = exports.getEmptyContentTreeMap = exports.traverseMapForPath = exports.ContentTreeMapFactory = void 0;
const assert_1 = __importDefault(require("assert"));
const contentTree_1 = require("./contentTree");
const types_1 = require("./types");
const ContentPath_1 = require("../ContentPath");
// Essentially a nested ES6 map for our dynamically nested content structure
// The base of the map is a set containing a configurable (<V>) data type, so that this can be flexible
class ContentTreeMapFactory {
    constructor(contentTree, getDefaultFillObj) {
        this.depth = 0; // set in initEmptyContentTreeMap
        this.contentTreeMap = new Map();
        this.contentIDToNameMap = new Map();
        this.initEmptyContentTreeMap(contentTree, [], getDefaultFillObj);
    }
    get emptyContentTreeMap() {
        return this.contentTreeMap;
    }
    // recursively search tree (depth-first, pre-order traversal)
    initEmptyContentTreeMap(contentTree, contentPath, getDefaultFillObj) {
        if ((0, contentTree_1.isContentTreeImmediatelyAboveBase)(contentTree)) {
            // we are at the base of the content tree map now
            const baseMap = (0, exports.traverseMapForPath)(this.contentTreeMap, contentPath);
            (0, assert_1.default)((0, types_1.isReturnFromTraversalBaseMap)(baseMap), `Unexpected returned content tree for base map (expected base map for content path: ${contentPath})`);
            for (const baseContent of contentTree.children) {
                baseMap.set(baseContent.id, getDefaultFillObj());
                this.contentIDToNameMap.set(baseContent.id, baseContent.name);
            }
            if (!this.depth)
                this.depth = contentPath.length + 1;
        }
        else {
            for (const nonBaseContent of contentTree.children) {
                // not at the base of the content tree map
                const nonBaseMap = (0, exports.traverseMapForPath)(this.contentTreeMap, contentPath);
                (0, assert_1.default)((0, types_1.isReturnFromTraversalNonBaseMap)(nonBaseMap), `Unexpected returned content tree for non-base map (expected non-base map for content path: ${contentPath})`);
                nonBaseMap.set(nonBaseContent.id, new Map());
                this.contentIDToNameMap.set(nonBaseContent.id, nonBaseContent.name);
                this.initEmptyContentTreeMap(nonBaseContent, [...contentPath, nonBaseContent.id], getDefaultFillObj);
            }
        }
    }
}
exports.ContentTreeMapFactory = ContentTreeMapFactory;
// used externally as well
const traverseMapForPath = (contentTreeMap, contentPath) => {
    let outputMap = contentTreeMap;
    for (const node of contentPath) {
        (0, assert_1.default)(!(0, types_1.isReturnFromTraversalBaseType)(outputMap), `Unexpected format of returned map (expected: not base set for content path: ${(0, ContentPath_1.hashContentPath)(contentPath)})`);
        outputMap = outputMap.get(node);
    }
    return outputMap;
};
exports.traverseMapForPath = traverseMapForPath;
const getEmptyContentTreeMap = (contentTree, getDefaultFillObj) => {
    const emptyContentTreeMapFactory = new ContentTreeMapFactory(contentTree, getDefaultFillObj);
    return {
        contentTreeMap: emptyContentTreeMapFactory.emptyContentTreeMap,
        depth: emptyContentTreeMapFactory.depth,
        contentIDToNameMap: emptyContentTreeMapFactory.contentIDToNameMap,
    };
};
exports.getEmptyContentTreeMap = getEmptyContentTreeMap;
const walkContentTreeMap = (contentTreeMap, contentPath, leafNodeCallback, subtreeCallback) => {
    const node = (0, exports.traverseMapForPath)(contentTreeMap, contentPath);
    if ((0, types_1.isReturnFromTraversalBaseType)(node)) {
        leafNodeCallback(node, contentPath);
    }
    else {
        subtreeCallback(node, contentPath);
        for (const key of node.keys()) {
            const currentPath = [...contentPath, key];
            (0, exports.walkContentTreeMap)(contentTreeMap, currentPath, leafNodeCallback, subtreeCallback);
        }
    }
};
exports.walkContentTreeMap = walkContentTreeMap;
//# sourceMappingURL=contentTreeMap.js.map